export default function GET_PROJECT_STATISTICS_FIELDS(): string {
    return `
        id
        thumbnail
        title
        order
        post_content
        post_date
        nomination
        prize
        is_verified 
        actualRating
        track {
            id
            title
        }
        fmru_destrict {
            id
            title
        }
        fmru_school {
            id
            title
        }
        honeycombs {
            id
            title
        }
        fmru_group_player {
            id
            title
            thumbnail
            color
            post_content
        }
        tutor {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        leader {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        member0 {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        member1 {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        member2 {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        member3 {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        member4 {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        member5 {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        member6 {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        member7 {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        member8 {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        member9 {
            id
            display_name
            user_email
            external
            externalId
            avatar
        }
        experts {
            id
            display_name
            roles
            avatar
        }
        correctMemberRate {
            rate
            description
            user 
            display_name
            unixtime
        }
        ratings { 
            display_name 
            criteryId
            rating 
            description
            correct_rating 
            correct_description
            correct_display_name
        }
        exhortations {
            author {
                display_name
            }
            descr
        }
        verified_reason
    `
}